import { render } from "./PreCreatedDayProjectAssignment.vue?vue&type=template&id=a5163b1a&scoped=true"
import script from "./PreCreatedDayProjectAssignment.vue?vue&type=script&lang=js"
export * from "./PreCreatedDayProjectAssignment.vue?vue&type=script&lang=js"

import "./PreCreatedDayProjectAssignment.vue?vue&type=style&index=0&id=a5163b1a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5163b1a"]])

export default __exports__